// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WideSpinner__container__pXF6C {
  align-items: center;
  display: flex;
  height: 100px;
  justify-content: center;
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/shared/components/WideSpinner.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,WAAA;AACF","sourcesContent":[".container {\n  align-items: center;\n  display: flex;\n  height: 100px;\n  justify-content: center;\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `WideSpinner__container__pXF6C`
};
export default ___CSS_LOADER_EXPORT___;
